import { setAddonsInUseAction as setAddonsInUseOperation } from 'editor/src/store/editorModules/addons/slice';

export default setAddonsInUseOperation;
